import { campaign, logo, description, dois, links, legends, defaultCamera, instrumentLayers } from "./components";

const hs3_campaign = {
    title: `${campaign} Field Campaign`,
    logo: logo,
    description: description,
    links: links,
    dois: dois,
    legends: legends,
    defaultCamera: defaultCamera,
    layers: instrumentLayers
}

export default hs3_campaign